module.exports = __webpack_public_path__ + "img/time_frame.92badaf6.png";